export function maskStyle(name) {
  const v = `url("/img/${name}.svg") center / contain no-repeat`;
  return { WebkitMask: v, mask: v };
}

export function Icon({ name, src, w, h, size, color, className, style }) {
  const iconName = name || (src ? src.replace(/^.*\//, '').replace(/\.svg$/, '') : '');
  const width = w || size;
  const height = h || size;
  return (
    <i
      className={`icon${className ? ` ${className}` : ''}`}
      style={{
        ...maskStyle(iconName),
        backgroundColor: color,
        width,
        height,
        ...style,
      }}
    />
  );
}
